import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  IconController,
  ImgController,
} from "../../../../Scripts/ImgController";
import assets from "../../../../../assets/assets";

const FixedWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  background: #00000088;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.6ms ease;

  .modal-animate {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }

  .modal-show {
    opacity: 1;
    transform: translateY(0);
  }

  .border-CK2 {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    background: white;
    max-width: 814px;
    width: 100%;
    z-index: 100;
  }

  .paragraph-CK {
    color: #344054;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-basis: 30%;
  }
`;

const Modal = ({ showModal, section, onClose }) => {
  const modalRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (showModal) {
      setTimeout(() => setAnimate(true), 10);
    } else {
      setAnimate(false);
    }
  }, [showModal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  if (!showModal) return null;

  return (
    <FixedWrapper>
      <div
        className={`modal-animate ${animate ? "modal-show" : ""}`}
        ref={modalRef}
      >
        {section.map((section, i) => (
          <div key={i} className="border-CK2 relative overflow-hidden">
            {/* Header */}
            <div className="w-full border-b border-[#E4E7EC] z-50">
              <div className="flex justify-between items-start gap-6 p-6">
                <div className="h-fit p-2 bg-mmusic rounded-xl">
                  <IconController
                    src={assets.svg.fileEditWhite}
                    alt="Mmusic Logo"
                    className="h-9 w-9"
                  />
                </div>
                <div className="w-full pr-6">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-lg leading-7 text-[#0B0C0F]">
                      {section.title}
                    </h3>
                    {section.global_badge ? (
                      <span className="badge-gradient_2 text-white px-3 py-1.5 rounded-full">
                        <div className="flex items-center">
                          <span className="text-xs font-bold pr-2">
                            {section?.global_badge}
                          </span>

                          <ImgController
                            src={assets.image.MetaIcon}
                            alt="Mmusic Logo"
                            className="h-3 w-14"
                          />
                        </div>
                      </span>
                    ) : (
                      ""
                    )}

                    <span
                      className={`badge-gradient text-white  px-3 py-0.5 rounded-full`}
                    >
                      <span className="text-xs font-bold pr-2">
                        {section.badge}
                      </span>
                      <span className="text-sm font-extrabold">
                        {section.percentage}
                      </span>
                    </span>
                  </div>
                  <h5 className="text-sm font-normal text-[#475467] pt-1">
                    {section.subTitle}
                  </h5>
                </div>
                <button onClick={onClose}>
                  <IconController src={assets.svg.close} alt="Mmusic Logo" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex">
              <div className="w-full">
                <div className="p-6 pb-9">
                  <div className="w-full space-y-4 text-sm">
                    {section.content.map((item, idx) => (
                      <div key={idx} className="pt-1">
                        <p className="text-xs leading-5">{item.list}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </FixedWrapper>
  );
};

export default Modal;
